import request from "@/lib/api/handler";
import { useAuth0 } from "@auth0/auth0-react";
import { useQuery } from "@tanstack/react-query";
import { QueryKeys } from "../utils";
import {
  ReferenceRelationship,
  ReferenceStatus,
} from "@/redux/features/candidateProfileSlice";

export interface AdminReference {
  id: string;
  referenceName?: string;
  email?: string;
  company?: string;
  title?: string;
  relationship?: ReferenceRelationship;
  message?: string;
  responses: string[];
  status: ReferenceStatus;
  surveyLink: string;
  user: {
    id: string;
    name?: string;
    profilePictureLink?: string;
  };
  firstRequestDate: string;
  mostRecentRequestDate: string;
  requestCount: number;
}

export const useAdminReferencesQuery = () => {
  const { getAccessTokenSilently } = useAuth0();
  const {
    data: adminReferences,
    error: adminReferencesError,
    isLoading: adminReferencesLoading,
  } = useQuery({
    queryKey: QueryKeys.adminReferences,
    enabled: true,
    refetchOnWindowFocus: false,
    staleTime: Infinity,
    async queryFn() {
      const token = await getAccessTokenSilently();
      return await request<AdminReference[]>({
        method: "GET",
        path: "/api/admin/references",
        token,
      });
    },
  });

  return {
    adminReferences,
    adminReferencesError,
    adminReferencesLoading,
  };
};
